import { createSelector } from 'reselect';

export const selectClaimDossier = (state: any) => state.get('claimToPreopen');

const makeSelecClaimToPreopen = () =>
  createSelector(selectClaimDossier, (claimDossier: any) => {
    if (claimDossier && claimDossier.get('claim')) {
      return claimDossier.get('claim').toJS();
    }
    return {};
  });
const makeSelectClaimId = () =>
  createSelector(selectClaimDossier, (claimDossier: any) => {
    if (claimDossier && claimDossier.get('claimId')) {
      return claimDossier.get('claimId').toJS();
    }
    return {};
  });

const makeSelectIsProvisionalClaimExist = () =>
  createSelector(selectClaimDossier, (claimDossier: any) => {
    if (claimDossier) {
      const value = claimDossier.get('isProvisionalClaimExist');
      return value && value.toJS ? value.toJS() : value;
    }
    return null;
  });

export {
  makeSelecClaimToPreopen,
  makeSelectClaimId,
  makeSelectIsProvisionalClaimExist,
};
